import React, { useState, useEffect } from 'react';
import HeavySetDataContext from './context/HeavySetDataContext'
import Dashboard from './components/Dashboard/Dashboard';
import CSVHeader from './components/CSVUpload/CSVHeader';
import CSVUpload from './components/CSVUpload/CSVUpload';
import CSVFooter from './components/CSVUpload/CSVFooter';
import GlobalStyles from './styles/GlobalStyle';
import styled from 'styled-components';
// Demo data
import { mockData } from './data/mock-data';
import { mockWorkouts } from './data/mock-workouts';
import { mockExercises } from './data/mock-exercises';

const HeavySetAnalytics = styled.div`
  color: #434c5e;
  background-color: #eceff4;
  -webkit-font-smoothing: antialiased;
`;

const CSVWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
`;

function App() {
  const savedHeavySetData = JSON.parse(localStorage.getItem('heavySetAnalyticsData'));
  const savedHeavySetWorkouts = JSON.parse(localStorage.getItem('heavySetAnalyticsWorkouts'));
  const savedHeavySetExercises = JSON.parse(localStorage.getItem('heavySetAnalyticsExercises'));
  const [heavyData, setHeavyData] = useState(savedHeavySetData);
  const [uniqueWorkouts, setUniqueWorkouts] = useState(savedHeavySetWorkouts);
  const [uniqueExercises, setUniqueExercises] = useState(savedHeavySetExercises);

  const getHeavyData = (data) => setHeavyData(data);
  const getWorkouts = (data) => setUniqueWorkouts(data);
  const getExercises = (data) => setUniqueExercises(data);

  console.log('heavyData', heavyData);

  useEffect(() => {
    if (!heavyData) {
      setHeavyData(mockData);
      setUniqueWorkouts(mockWorkouts);
      setUniqueExercises(mockExercises)
    }
  }, [heavyData]);

  useEffect(() => {
    if (heavyData) {
      localStorage.setItem('heavySetAnalyticsData', JSON.stringify(heavyData));
    }
  }, [heavyData]);

  useEffect(() => {
    if (uniqueWorkouts) {
      localStorage.setItem('heavySetAnalyticsWorkouts', JSON.stringify(uniqueWorkouts));
    }
  }, [uniqueWorkouts]);

  useEffect(() => {
    if (uniqueExercises) {
      localStorage.setItem('heavySetAnalyticsExercises', JSON.stringify(uniqueExercises));
    }
  }, [uniqueExercises]);

  return (
    <>
      <GlobalStyles />
      <HeavySetAnalytics>
        {
          heavyData
            ? (
              <HeavySetDataContext.Provider value={heavyData}>
                <Dashboard
                  workouts={uniqueWorkouts}
                  exercises={uniqueExercises}
                  getHeavyData={getHeavyData}
                  getWorkouts={getWorkouts}
                  getExercises={getExercises}
                />
              </HeavySetDataContext.Provider>
            ) : (
              <CSVWrap>
                <CSVHeader />
                <CSVUpload
                  getHeavyData={getHeavyData}
                  getWorkouts={getWorkouts}
                  getExercises={getExercises}
                />
                <CSVFooter />
              </CSVWrap>

            )
        }
      </HeavySetAnalytics>
    </>
  );
}

export default App;
